var map = {
	"./SignPainter-HouseScript.ttf": 88,
	"./proximasoft-bold-webfont.ttf": 91,
	"./proximasoft-regular-webfont.ttf": 95
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font ^\.\/.*\.ttf$
// module id = 33
// module chunks = d-game